<template>
    <el-container class="app-wrap">
        <el-aside class="app-side" width="auto">
            <side-bar></side-bar>
        </el-aside>
        <el-container>
            <el-header height="50px" class="app-header">
                <header-info :comment-monthly="true" :comment-daily="true">
                    <template #header-search>
                        <!-- <span> -->
                        <!-- <el-input v-model="inputValue" class="home-header-input-box" size="mini"
                                placeholder="搜索客户、商机、合同..." clearable @input="inputHandle"
                                @keydown.enter.native="handleIconClick">
                                <i slot="suffix" class="custom-icon" @click="handleIconClick"></i>
                            </el-input> -->
                        <!-- </span> -->
                        <!-- <div class="search-head-box">
                            <inputComplete widthPopper="268" inputClass="home-header-input-box"
                                @handleIconClick="handleIconClick" @inputHandle="inputHandle" :inputValue="inputValue"
                                @clickItem="clickItem">
                            </inputComplete>
                        </div> -->
                    </template>
                </header-info>
            </el-header>
            <el-main class="app-main">
                <keep-alive :exclude="notAlivePageNamesArr">
                    <router-view></router-view>
                </keep-alive>
            </el-main>
        </el-container>
        <warn-alert></warn-alert>
        <FeedBack />
    </el-container>
</template>
<script>
import SideBar from '@/components/core/SideBar';
import HeaderInfo from '@/components/core/HeaderInfo';
import WarnAlert from '@/components/core/WarnAlert';
import { notAlivePageNames, changeFlag } from '@/utils/keepAliveCfg.js';
import FeedBack from '@/components/Feedback/index';
import store from './store';
import { Message } from 'element-ui';
import { createWatermark } from '@/utils/waterMark';
// import inputComplete from './views/index/inputComplete/Index.vue';
export default {
    name: 'app',
    components: { SideBar, HeaderInfo, WarnAlert, FeedBack },
    data() {
        return {
            inputValue: '',
            notAlivePageNames,
            changeFlag
        };
    },
    computed: {
        notAlivePageNamesArr() {
            return this.changeFlag.flag ? [...this.notAlivePageNames] : [];
        }
    },
    mounted() {
        const userCode = store.state.user.user.userCode;
        const userName = store.state.user.user.userName;
        if (userCode && userName) {
            // 设置水印
            createWatermark({
                className: 'lcrm-body-box',
                text: `${userName}(${userCode})`
            });
        }
    },
    methods: {
        inputHandle(val) {
            this.inputValue = val;
        },

        handleIconClick(val) {
            if (this.inputValue === '') {
                return Message.warning('请输入要搜索的内容');
            }
            if (this.$route.name === 'search') {
                store.commit('updateHomeSearchInput', this.inputValue);
                this.inputValue = '';
                return;
            }
            this.$router.push({ name: 'search', params: { inputValue: this.inputValue } });
            this.inputValue = '';
        },
        clickItem(val) {
            this.inputValue = val;
            if (this.$route.name === 'search') {
                store.commit('updateHomeSearchInput', this.inputValue);
                this.inputValue = '';
                return;
            }
            this.$router.push({ name: 'search', params: { inputValue: this.inputValue } });
            this.inputValue = '';
        }
    }
};
</script>
<style lang="less" scoped>
.search-head-box {
    display: inline-block;

}
</style>
<style lang="less">
.home-header-input-box {
    width: 268px !important;
    height: 30px !important;
    background: #FFFFFF;
    border-radius: 15px;

    .custom-icon {
        background: url('./assets/images/icon-header-search.png') center/cover;
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 12px;
        margin-top: 9px;
        cursor: pointer;
    }
}

// 滚动条相关配置
@scrollbarThumbColor: rgba(0, 0, 0, .1);
@scrollbarThumbColorHover: rgba(0, 0, 0, .4);

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

// 滚动块样式
::-webkit-scrollbar-thumb {
    background-color: @scrollbarThumbColor;
    background-clip: padding-box;
    min-height: 28px;
    border-radius: 2em;
}

::-webkit-scrollbar-thumb:hover {
    background-color: @scrollbarThumbColorHover;
}

.app-wrap {
    height: 100%;

    .app-side {
        background: #1e1e28;
    }

    .app-header {
        padding: 0;
        box-shadow: 0 1px 5px rgba(0, 0, 0, .1);
        position: relative;
        z-index: 99;
    }

    .app-main {
        padding: 10px;
        background: #f3f4f6;
        display: flex;
    }
}

.el-dropdown-menu {
    .el-dropdown-menu__item {
        .dropdown-item-span {
            color: #4285f5;
        }

        &.dropdown-item {
            width: 60px;

            &:hover {
                background-color: #ecf5ff;

                .dropdown-item-span {
                    color: #4285f5;
                }
            }
        }
    }
}

.el-table th.el-table__cell {
    background-color: #f5f6f7;
}

.home-header-input-box.el-input .el-input__inner {
    border-radius: 18px !important;
    padding-left: 12px;
    padding-right: 46px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #333333;

}

.home-header-input-box {
    .el-input__suffix {
        &-inner {
            flex-direction: row-reverse;
            -webkit-flex-direction: row-reverse;
            display: flex;
        }

        .el-input__clear {
            width: 24px;
            line-height: 30px !important;
        }
    }

}
.el-tooltip__popper {
    max-width: calc(100vw - 40px);
    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-line!important;
}
.el-table__fixed,
.el-table__fixed-right{
    background-color: #fff; // 表格固定列背景丢失兼容问题
    z-index: 10;
}
</style>
